module.exports = __webpack_public_path__ + "static/media/29FUNOV3.c2423e61.jpg";